import { graphql } from '@/gql/graphql';
import { ChatMessageEmojiInputFragment } from './ChatMessageEmojiInput.utils';

export const ChatMessageItemFragment = graphql(`
  fragment ChatMessageItem on message {
    id
    content
    content_template
    created_at
    deleted_at
    edited_at
    chat_id
    creator {
      id
      avatar_id
      name
      color
    }
    mentions {
      id
      fallback_label
      person_id
      person {
        id
        name
      }
    }
    media(order_by: { order: asc }) {
      id
      created_by
      media_id
      order
      url
      mime_type
      og_title
      og_description
      og_image_height
      og_image_width
      og_image_url
    }
    reaction_count
    ...ChatMessageEmojiInput
  }
`, [ChatMessageEmojiInputFragment]);
